import Axios from 'axios';
import * as TokenHelpers from '../utils/tokenHelpers';
import * as ApiHelper from '../utils/apiHelper';


export function getStripeCustomer() {

  return new Promise((resolve, reject) => {

    let user = TokenHelpers.decode();
    if(!user) {
      return reject('Failed to decode user token');
    }
    Axios({
      url: `${ApiHelper.API_ROOT}/customers/stripe?stripeID=${user.stripeID}`,
      method: 'get',
      headers: ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve())
    })
    .then(response => resolve(response.data))
    .catch(ApiHelper.handleUserAuth).catch(error => reject({error: error.response.data}))
  })
}

export function createCheckoutSession(data){
  return new Promise((resolve, reject) => {
    const path = ApiHelper.API_ROOT+'/customers/stripe-checkout';
    const headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'POST',
      data: data,
      headers: headers
    })
    .then(response => {
      resolve(response.data);
    }).catch(error => {
      reject({error: error.response.data})
    });
  });
};


export function getPaymentMethodById(cardId, cards) {

  if(!cards) {
    console.error('cards required to get card by id');
    return;
  }

  let paymentMethod;
  cards.forEach(function(card) {
    if (card.id === cardId)
      paymentMethod = card;
    }
  );
  return paymentMethod;
}

export function postSetUpIntent() {

  return new Promise((resolve, reject) => {
    const path = ApiHelper.API_ROOT+'/customers/payment-methods';
    const headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'POST',
      data: {},
      headers: headers
    })
    .then(response => {
      resolve(response.data);
    }).catch(error => {
      reject({error: error.response.data})
    });
  });
}

export function getAllCustomerPaymentMethods(){
  return new Promise((resolve, reject) => {
    let path = ApiHelper.API_ROOT+'/customers/payment-methods';
    const headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'GET',
      headers: headers
    })
    .then(response => {
      console.log("post response ", response.data);
      resolve(response.data)
    })
    .catch(ApiHelper.handleUserAuth).catch(error => {
      console.log("post error", error);
      reject({error: error.response.data})
    });
  })
}

export function deleteCustomerPaymentMethod(paymentMethodId){
  return new Promise((resolve, reject) => {
    let path = ApiHelper.API_ROOT+'/customers/payment-methods';
    const headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'DELETE',
      data: {
        paymentMethodId
      },
      headers: headers
    })
    .then(response => {
      console.log("Delete response ", response.data);
      resolve(response.data)
    })
    .catch(ApiHelper.handleUserAuth).catch(error => {
      console.log("delete error", error);
      reject({error: error.response.data})
    });
  })
}


// WEBPACK FOOTER //
// ./src/services/payments.js